<div
  class="option-container group transition-all duration-200"
  [class.option--active]="isSelected"
  [class.option--error]="isValid"
>
  <div
    class="grid grid-cols-[auto_1fr_auto] items-center p-4 border rounded-lg hover:bg-slate-50 cursor-pointer"
  >
    <div class="option_slotleft flex items-center justify-center">
      <ng-content select="[slotLeft]"></ng-content>
    </div>

    <div class="option_slotmiddle ml-4">
      <ng-content select="[slotMiddle]"></ng-content>
    </div>

    <div class="option_slotright">
      <ng-content select="[slotRight]"></ng-content>
    </div>
  </div>
  <div class="option_slotunder col-span-3" >
    <ng-content select="[slotUnder]"></ng-content>
  </div>
</div>
